import { useState } from "react";
import { createContainer } from "unstated-next";
import { ShopService } from "../services/ShopService";

export type Shop = {
  id: string;
  name: string;
  image: string;
  floor: string;
  basicInfo?: ShopBasicInfo;
};

export type ShopBasicInfo = {
  description?: string;
  banner?: string;
  genre?: string;
  budget?: string;
  businessHours?: string;
  tel?: string;
  others?: string;
};

/**
 * 店舗一覧コンテナ
 */
const useShopsContainer = () => {
  const [shops, setShops] = useState<Shop[] | undefined>(undefined);

  /**
   * 店舗一覧を取得
   */
  const getShopList = async (campaignId: string) => {
    const shopDataList = await ShopService().getShopList(campaignId);
    const shops = shopDataList.map((shop) => {
      return {
        id: shop.id,
        name: shop.data.displayName,
        image: shop.data.image,
        floor: shop.data.floor,
        basicInfo: shop.data.basicInfo,
      };
    });

    setShops(shops);
  };

  return { shops, getShopList };
};

export const ShopContainer = createContainer(useShopsContainer);
